import Business from '@constants/Business'

export default function searchInput (baseUrl) {
    const url = Business.host + baseUrl
    return {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "url": url || Business.host,
        "potentialAction": {
          "@type": "SearchAction",
          "target": `${url}?fraza={search_term_string}`,
          "query-input": "required name=search_term_string"
        }
    }
}